// extracted by mini-css-extract-plugin
export default {"tooltip":"rP-z","arrow":"sP-z"};